import Fragment from "./fragment";
import FragmentDataType from "../enums/fragment-data-type";
import FragmentSummary from "./fragment-summary";
import { playerReducer } from "../../../storage/reducers";
import { FragmentMessages } from "../../common/fragment-messages";
import FootballState from "../state/football-state";

export default class KickRecovered extends Fragment {
    constructor(recoveredBy, recoveredAt) {
        super();
        this.recoveredBy = recoveredBy;
        this.recoveredAt = recoveredAt;

        this.requiredData = [
            {
                name: "recoveredBy",
                type: FragmentDataType.Player,
                appliesToOpponent: () => false,
                displayName: "Recovered By",
                title: (team) => `Recovered By: ${team.teamName}`,
                subtitle: (team) =>
                    `Select a player
                     from ${team.teamName} or enter the roster number`,
                isEditable: true
            },
            {
                name: "recoveredAt",
                type: FragmentDataType.FieldPosition,
                displayName: "Recovered At",
                title: "At",
                subtitle: FragmentMessages.FB_TEAM_FIELD_POSITION,
                showEndZoneYards: (gameConfig) =>
                    gameConfig.general.includeEndZoneYardage
            }
        ];
    }

    getFragmentTeamId() {
        return this.recoveredBy?.teamId;
    }

    changesPossession(currentPossessionId) {
        return this.recoveredBy?.teamId != currentPossessionId;
    }

    dirtiesPlaySequence(fragment) {
        return (
            this.recoveredBy &&
            this.recoveredBy?.teamId != fragment.recoveredBy?.teamId
        );
    }

    getPlayers() {
        return [this.recoveredBy];
    }

    getFieldPosition() {
        return this.recoveredAt;
    }

    summarize(summaryContext, stringifier, play) {
        const isOnSideKickPlay =
            play.getPreceedingFragment(this, FootballState.OnSide)
                ?.associatedState === FootballState.OnSide;

        if (this.recoveredBy) {
            const homeRecovery =
                this.recoveredBy.teamId === summaryContext.homeTeamId;
            const recoveryTeam = homeRecovery
                ? summaryContext.homeTeam
                : summaryContext.awayTeam;

            const messages = [
                `recovered for ${stringifier.gain(
                    Object.assign(summaryContext, {
                        homeTeamHasPossession: homeRecovery
                    }),
                    summaryContext.fieldPosition,
                    this.recoveredAt
                )} by`
            ];

            if (isOnSideKickPlay) {
                messages.push(`${recoveryTeam.teamName}`);
            }
            messages.push(`${stringifier.firstInitial(this.recoveredBy)}`);

            return new FragmentSummary(messages.join(" "));
        } else {
            return new FragmentSummary("");
        }
    }

    updateSummaryContext(summaryContext) {
        if (this.recoveredBy) {
            summaryContext.homeTeamHasPossession =
                this.recoveredBy.teamId === summaryContext.homeTeamId;

            if (this.recoveredAt || this.recoveredAt === 0) {
                summaryContext.fieldPosition = this.recoveredAt;
            }
            summaryContext.playerInPossession = this.recoveredBy;
        }
    }

    toJSON() {
        return {
            ...super.toJSON(),
            recoveredBy: playerReducer(this.recoveredBy)
        };
    }
}
